// extracted by mini-css-extract-plugin
module.exports = {"container":"da51a739f7--container--smBbo","text":"da51a739f7--text--krBH0","formatted":"da51a739f7--formatted--bWAnS"};